var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center content-toast"},[_c('b-toast',{attrs:{"variant":_vm.variant,"message":_vm.message}},_vm._l((_vm.message),function(text){return _c('p',{key:text},[_vm._v(" "+_vm._s(text)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }